import { truncateMessagePreview } from '../TeamChat.utils';

import { REPLY_PREVIEW_MAX_CHARS } from './TeamChatReplyPreview.constants';

export const buildReplyPreview = text => truncateMessagePreview(text, REPLY_PREVIEW_MAX_CHARS);
